import { NavLink as _NavLink, NavLinkProps as _NavLinkProps } from "reactstrap";

    export const NavLink = _NavLink;
    export type NavLinkProps = _NavLinkProps;
    